fragment ChatSettingsFragment on ChatSettings {
    isChatEnabled
    intakeForm {
        fields
        message
        type
        shouldCreateLeads
        shouldCreateLeadsPipelineId
        allowThreadsWithoutContact
    }
    lookAndFeel {
        color
        secondaryColor
        nameDisplay
        nudgeSettings {
            isEnabled
            message
            callToAction
            deviceVisibility
        }
        icon {
            type
            url
        }
        conversationStarter
        showPoweredBy
        disclaimerSettings {
            isEnabled
            message
        }
        actionBarShownActions
        actionBarHiddenActions
        chatVariant
        chatbotName
        chatbotIconEnum
        disabledPaths
    }
    offline {
        isEnabled
        form {
            id
            publicFormId
            name
            htmlUrlPath
            lastSubmittedTime
            numSubmissions
        }
        formType
        message
        conversationalMessage
    }
    assignment {
        strategy
        user {
            id
        }
    }
    embedScript
    chatbot {
        responseTiming
        name
        iconEnum
        tone
        answerLength
        suggestions
        topicsToAvoid
    }
    goals {
        schedulerIsEnabled
        schedulerMeetingId
        formIsEnabled
        formSlug
    }
}
